// TinyMCE bundled setup — all assets imported via webpack so no HTTP skin requests are needed.
// This avoids the "toolbar not visible" issue caused by missing skin CSS files at runtime.

// Import tinymce core and expose it globally so themes/plugins can find it
const tinymce = require('tinymce')
globalThis.tinymce = tinymce

// Core theme and model (required for TinyMCE 7)
require('tinymce/themes/silver')
require('tinymce/models/dom')
require('tinymce/icons/default')

// Oxide skin CSS — bundled so TinyMCE does not fetch it from a URL
require('tinymce/skins/ui/oxide/skin.min.css')

// Plugins used in the mail-template editors
require('tinymce/plugins/advlist')
require('tinymce/plugins/autolink')
require('tinymce/plugins/lists')
require('tinymce/plugins/link')
require('tinymce/plugins/image')
require('tinymce/plugins/charmap')
require('tinymce/plugins/preview')
require('tinymce/plugins/anchor')
require('tinymce/plugins/pagebreak')
require('tinymce/plugins/searchreplace')
require('tinymce/plugins/visualblocks')
require('tinymce/plugins/code')
require('tinymce/plugins/fullscreen')
require('tinymce/plugins/insertdatetime')
require('tinymce/plugins/media')
require('tinymce/plugins/table')
require('tinymce/plugins/wordcount')
